import styled from 'styled-components'
import { breakpoints } from '../../../../../constants'
import {
	MEDIUMORANGE,
	WHITE,
	DARKGRAY
} from '../../../../../styles/colors.style'

export const Container = styled.section`
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 40px 10px;

	@media (min-width: ${breakpoints.MOBILE}px) {
	}
`

export const Header = styled.header`
	padding-bottom: 20px;

	h2 {
		font: 600 22px/28px 'Source Sans Pro';
		text-align: center;
		color: ${DARKGRAY};
	}

	@media (min-width: ${breakpoints.MOBILE}px) {
	}
`

export const Box = styled.div``

export const Text = styled.p`
	font: 14px/18px 'Source Sans Pro';
	text-align: center;
	padding-bottom: 20px;
	color: ${DARKGRAY};

	strong {
		font-size: 20px;
	}
`

export const Button = styled.button`
	display: block;
	margin: 0 auto;
	padding: 0 10px;
	height: 45px;
	border-radius: 5px;
	border: 0;
	color: ${WHITE};
	background: ${MEDIUMORANGE};
	font: 600 15px/25px 'Source Sans Pro';
	cursor: pointer;
`
